import axios from "axios";
import config from "../config";

export const getTemplates = async () => {
    const {data} = await axios(config.templatesUrl, {withCredentials: true});
    return data;
};
